import React, { Component, useState } from "react";
import { Translation } from "react-i18next";
import i18n from "i18next";
import { styles } from "./Preview.css";
import { connect } from "react-redux";
import {
  Button,
  MenuItem,
  Select,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  TablePagination,
  Checkbox,
  Tabs,
  AppBar,
  Tab,
  Box,
  Paper,
  withStyles,
  IconButton,
  FormControlLabel,
} from "@material-ui/core";
import { MdMessage } from "react-icons/md";
import clsx from "clsx";
import TextElement from "../../../util/preview-element/TextElement";
import Moment from "react-moment";
import { CFOrgStatusLabel } from "../../../redux/Types";
import UserDisplay from "../../../util/UserDisplay";
import genre from "../../../_module/definition/genre";
import { NumberDisplay, userDisplay } from "../../../util/CommonFunc";
import { __getTrackStatusByID } from "../../../_clearance/utils/utils";
import TrackHistory from "../../../util/history/TrackHistory";
import TextElementClearance from "../../../util/preview-element/TextElementClearance";
import { isHeaderQuestion, __getQuestionAndAnswer } from "../../../_clearance/utils/utils";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}


class ClearanceDetails extends Component {

  constructor(props) {
    super();
    this.state = {
      dialogOpen: false,
      tabValue: 0,
      showDetails: false
    }
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  openDialog() {
    this.setState({
      dialogOpen: true,
    });
  }

  closeDialog() {

    this.setState({
      dialogOpen: false,

    });
  }

  a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  getStatus = (id) => {
    const {
      runtime: { loading, runtime },
    } = this.props;
    if (loading) return { name: "", color: "" };
    return __getTrackStatusByID(id, runtime?._statuses || []);
  };

  render() {
    const {
      classes,
      runtime: { loading, errors, runtime },
      data: {
        editing,
        history,
        selectedItem,
      },
      focusTrack: rowData,
      orgRuntime, 
    } = this.props;

    let statusColor = this.getStatus(rowData.clearancestatus);

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <IconButton
              title="Clearance Details"
              className={clsx(classes.clearanceInfoPopup, 'clearanceIconSVG')}
              aria-controls="Clearance Details Popup"
              aria-haspopup="true"
              onClick={this.openDialog}
            >
              <MdMessage fill={statusColor.color ? statusColor.color : "#dbbf63"} />
            </IconButton >
            <Dialog
              open={this.state.dialogOpen}
              id="clearance-details"
              aria-labelledby="clearance-details-dialog"
              class="clearancePopup"
            >
              <DialogTitle>Clearance Details and History</DialogTitle>
              <DialogContent>
                <AppBar position="static">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChange}
                    scrollButtons="auto"
                    variant="scrollable"
                    className={classes.trackTabsHeader}
                  >
                    <Tab label="Clearance" {...this.a11yProps(0)} />
                    <Tab label="History" {...this.a11yProps(1)} />
                  </Tabs>
                </AppBar>
                {selectedItem?.id && (
                  <>
                    <TabPanel
                      className={classes.popupTabs}
                      value={this.state.tabValue}
                      index={0}
                    >
                      <Paper className={clsx(classes.paperwrap, classes.popupBox)}>
                        <div className={clsx(classes.muListWrap, classes.popupInnercontent)}>

                          {(runtime?._config?.CF_TRACK_ORG_STATUS?.LICENSED && +selectedItem.clearancestatus === +runtime?._config?.CF_TRACK_ORG_STATUS.LICENSED) && (
                            <>
                              {(selectedItem?.licensingInfoList && selectedItem?.licensingInfoList?.length > 0) && (
                                <>
                                  <TextElementClearance
                                    label="Budget / Fee"
                                    classes={classes}
                                    showCustomTitle
                                    customTitle={"Budget / Fee"}
                                    data={
                                      <>
                                        {selectedItem.licensingInfoList.map(d => {
                                          return (
                                            <div title={d.licensingName}>
                                              <div class="flexContainer grayContainer">
                                                <div class="licName" title={d.licensingName}>{d.licensingName}
                                                  <span> {(runtime?._config?.CF_LICENSING_TYPE_LIST || []).find(k => k.value === d.licensingType)?.label} </span>
                                                </div>
                                                <div class="licFee"> <NumberDisplay value={d.budget} /> </div>
                                              </div>
                                            </div>
                                          )
                                        })}
                                      </>
                                    }
                                  />
                                </>
                              )}
                              {selectedItem.licensingInfoNotes &&
                                <TextElement
                                  label="Notes (License)"
                                  classes={classes}
                                  data={selectedItem.licensingInfoNotes || "N/A"}
                                />}
                              {selectedItem.societyIndicatorMcps &&
                                <TextElement
                                  label="MCPS"
                                  classes={classes}
                                  data={selectedItem.societyIndicatorMcps ? (runtime?._config?.CF_SI_MCPS_TYPE_LIST || []).find(k => k.value === +selectedItem.societyIndicatorMcps)?.label : "N/A"}
                                />}
                              {selectedItem.societyIndicatorPpl &&
                                <TextElement
                                  label="PPL"
                                  classes={classes}
                                  data={
                                    selectedItem.societyIndicatorPpl ? (runtime?._config?.CF_SI_PPL_TYPE_LIST || []).find(k => k.value === +selectedItem.societyIndicatorPpl)?.label : "N/A"
                                  }
                                />}
                            </>
                          )}

                          <TextElementClearance
                            label="Status"

                            classes={classes}
                            showCustomTitle={true}
                            customTitle={
                              loading || !runtime
                                ? ""
                                : __getTrackStatusByID(
                                  selectedItem.clearancestatus,
                                  runtime._statuses
                                ).name || "NA"
                            }
                            data={
                              loading || !runtime ? (
                                <CircularProgress />
                              ) : __getTrackStatusByID(
                                selectedItem.clearancestatus,
                                runtime._statuses
                              ).name ? (
                                <span className={classes.clearanceTrafficContainer}>
                                  {__getTrackStatusByID(
                                    selectedItem.clearancestatus,
                                    runtime._statuses
                                  )?.color != 0 &&
                                    <span
                                      style={{
                                        background: loading
                                          ? ""
                                          : __getTrackStatusByID(
                                            selectedItem.clearancestatus,
                                            runtime._statuses
                                          ).color,
                                      }}
                                      className={classes.clearanceTrafficLight}
                                    ></span>
                                  }
                                  {
                                    __getTrackStatusByID(
                                      selectedItem.clearancestatus,
                                      runtime._statuses
                                    ).name
                                  }
                                </span>
                              ) : (
                                "NA"
                              )
                            }
                          />

                          {selectedItem.adminOverridden ? (
                            <>
                              <TextElementClearance

                                label="Overridden by"
                                classes={classes}
                                data={
                                  <UserDisplay userId={selectedItem.adminOverridden && selectedItem.adminOverriddenBy?selectedItem.adminOverriddenBy:selectedItem.updatedBy} />
                                }
                              />

                              <TextElementClearance
                                boldLabel={true}
                                label="With Notes"
                                classes={classes}
                                data={
                                  selectedItem.adminOverriddenWithNotes ||
                                  t("libraryPreview.na")
                                }
                              />
                            </>
                          ) : (
                            <>
                              <TextElementClearance
                                boldLabel={true}
                                label="Track Notes"
                                classes={classes}
                                data={selectedItem.trackNotes && Array.isArray(selectedItem.trackNotes) && selectedItem.trackNotes.length > 0 ? selectedItem.trackNotes.map((v, i) => {
                                  return <div>{i + 1} - {v}</div>
                                }) : t("libraryPreview.na")}
                                showCustomTitle
                                customTitle={selectedItem.trackNotes && Array.isArray(selectedItem.trackNotes) ? selectedItem.trackNotes.map((v, i) => {
                                  return `${i + 1} - ${v}`
                                }) : selectedItem.trackNotes || t("libraryPreview.na")}
                              />

                              {(
                                (editing?.clearance?.commits || [])[selectedItem.id]
                                  ?.next || []
                              )
                                .sort((a, b) => {
                                  if (isHeaderQuestion(a) && isHeaderQuestion(b)

                                  )
                                    return 0;
                                  else if (
                                    isHeaderQuestion(a)

                                  )
                                    return -1;
                                  else return 1;
                                })
                                .map((v, i) => {
                                  let qa = __getQuestionAndAnswer(
                                    editing?.clearance || {},
                                    v,
                                    selectedItem.id
                                  );
                                  return (
                                    <TextElementClearance

                                      label={qa.q}
                                      classes={classes}
                                      labelStyle={{
                                        color: qa.h ? "#FFC116" : "#00DCFF",
                                      }}
                                      style={{
                                        color: qa.h ? "#FFC116" : "#00DCFF",
                                      }}
                                      data={qa.a}
                                    />
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </Paper>
                    </TabPanel>
                    <TabPanel
                      value={this.state.tabValue}
                      index={1}
                      className={classes.popupTabs}
                    >
                      <>
                        <FormControlLabel
                          className={classes.clearanceCheckBoxForm}
                          control={
                            <Checkbox
                              checked={this.state.showDetails}
                              className={classes.clearanceCheckBox}
                              onChange={() => {
                                this.setState({
                                  showDetails: !this.state.showDetails
                                })
                              }}
                              inputProps={{
                                'aria-label': "Details on/off"
                              }}

                            />
                          }
                          label={!this.state.showDetails ? "Show Details" : "Hide Details"}
                        />
                      </>
                      <Paper className={clsx(classes.paperwrap, classes.popupBox)}>
                        <div className={clsx(classes.muListWrap, classes.popupInnercontent)}>
                          {history && editing?.id && ((selectedItem.clearanceFormId === editing.id && editing.id in history) || (selectedItem.clearanceFormId !== editing.id && selectedItem?.clearanceFormId in history)) ? (
                            <>
                              {history && history[selectedItem.clearanceFormId !== editing.id ? selectedItem.clearanceFormId : editing.id] && selectedItem?.trackDetails?.id && selectedItem?.trackDetails?.id in history[selectedItem.clearanceFormId !== editing.id ? selectedItem.clearanceFormId : editing.id] ? history[selectedItem.clearanceFormId !== editing.id ? selectedItem.clearanceFormId : editing.id][selectedItem?.trackDetails?.id].length == 0 ? <div class={classes.noData}> No History</div> : (
                                <>
                                  <TrackHistory
                                    orgRuntime={orgRuntime}
                                    showDetails={this.state.showDetails}
                                    data={history[selectedItem.clearanceFormId !== editing.id ? selectedItem.clearanceFormId : editing.id][selectedItem?.trackDetails?.id]}
                                    classes={classes}
                                    getStatus={(id) => this.getStatus(id)}
                                    migrated={(editing && runtime && runtime._config && editing[runtime._config.MIGRATED_FLAG]) || false}
                                  />
                                </>
                              ) : <CircularProgress className={classes.clearanceLoader} />}
                            </>
                          ) : <CircularProgress className={classes.clearanceLoader} />}
                        </div>
                      </Paper>
                    </TabPanel>
                  </>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  className={classes.dialogNoButton}
                  aria-label={"Close Popup"}
                  onClick={(e) => {
                    this.closeDialog();
                  }}
                  autoFocus
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mllicformcontent,
  runtime: state.clearanceRuntime,
  cfForm: state.mllicform,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
})(withStyles(styles)(ClearanceDetails));
